export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6252.687f800a.jpg";